import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  frame: {
    display: 'block',
    width: '100%',
    height: '100%',
  },
}))

export type Props = {}
export type Functions = {}

export type AllProps = Props & Functions

const Analytics: FunctionComponent<AllProps> = ({}) => {
  const styles = useStyles()

  return (
    <Box height="100%">
      <iframe
        src="https://app.powerbi.com/reportEmbed?reportId=f2f75f62-0f4b-4874-b6bd-2053d1efadb0&autoAuth=true&ctid=2787df5f-9501-4d10-89ee-c1ecbc26db45"
        frameBorder="0"
        allowFullScreen={true}
        className={styles.frame}
      ></iframe>
    </Box>
  )
}

export default Analytics
